import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getClassSessionConfig = createAsyncThunk(
	'accountClassSessionConfig/getClassSessionConfig',
	async (params: { AccountID: string }) => {
		console.log('getClassSessionConfig params', params);
		const { AccountID } = params;
		const response = await api.get(
		`/account/${AccountID.toLowerCase()}/class_session_config`, //params,
		{ timeout: 30000 }
		);
		// .then(response => {
		// 	console.log('getClassSessionConfig response', response);
		// 	return response.data;
		// })
		// .catch(error => {
		// 	console.log('getClassSessionConfig response error', error);
		// 	console.log('getClassSessionConfig response error', error.response.status);
		// 	if (error.response.status == 404){
		// 		throw new Error(`Not found`);
		// 	}
		// });
		console.log('getClassSessionConfig response', response);
		return response.data;
	}
);

export const enableClassSession = createAsyncThunk(
	'enableClassSession/enableClassSession',
	async (params: { AccountID: string; Enabled: boolean }) => {
		console.log('enableClassSession params ', params);
		const dataParams = {
		currentStatus: params.Enabled,
		};
		const response = await api.put(
		`/account/${params.AccountID.toLowerCase()}/enable_class_session`,
		dataParams,
		{ timeout: 30000 }
		);
		console.log('enableClassSession response', response);
		return response.data;
	}
);

export const updateConfig = createAsyncThunk(
	'updateConfig/updateConfig',
	async (params: any) => {
		console.log('updateConfig params ', params);
		let dataParams = Object.assign({}, params);
		delete dataParams.AccountID;
		console.log('>>>>>>', dataParams);
		const response = await api.put(
		`/account/${params.AccountID.toLowerCase()}/class_session_config`,
		dataParams,
		{ timeout: 30000 }
		);
		console.log('updateConfig response', response);
		return response.data;
	}
);

export const updateReminders = createAsyncThunk(
	'updateReminders/updateReminders',
	async (params: {
		AccountID: string;
		ReminderBeforeDays: number;
		ReminderBeforeMinutes: number;
	}) => {
		console.log('updateReminders params ', params);
		const dataParams = {
		ReminderBeforeDays: params.ReminderBeforeDays,
		ReminderBeforeMinutes: params.ReminderBeforeMinutes,
		};
		const response = await api.put(
		`/account/${params.AccountID.toLowerCase()}/class_session_reminder`,
		dataParams,
		{ timeout: 30000 }
		);
		console.log('updateReminders response', response);
		return response.data;
	}
);

const initialState: {
	status: string;
	error: string;
	config: any;
} = {
	status: '',
	error: '',
	config: {
		Enabled: false,
		ReminderBeforeDays: 0,
		ReminderBeforeMinutes: 0,
		TabNameLabel: 'Class',
		TabNameLabelPlural: 'Classes',
		HostLabel: 'Instructor',
		MaxParticipants : 8,
		MinMinutesToEdit : 60
	}, // config
};

const accountClassSessionConfigSlice = createSlice({
	name: 'accountClassSessionConfig',
	initialState: initialState,
	reducers: {
		accountSliceClean(state, action) {
		console.log('accountSliceClean', action);
		state.config.pending = false;
		state.config.complete = false;
		state.config.error = '';
		},
	},

  	extraReducers: (builder) => {
		//getClassSessionConfig
		builder.addCase(getClassSessionConfig.pending, (state) => {
			console.log('getClassSessionConfig.pending');
			state.config = {
				Enabled: false,
				ReminderBeforeDays: 0,
				ReminderBeforeMinutes: 0,
				TabNameLabel: 'Class',
				TabNameLabelPlural: 'Classes',
				HostLabel: 'Instructor',
			};
			
			state.config.pending = true;
			state.config.complete = false;
			state.config.error = '';
			
			});
			builder.addCase(getClassSessionConfig.fulfilled, (state, action) => {
			console.log('getClassSessionConfig.fulfilled ', action);
			state.config.pending = false;
			state.config.complete = false;
			state.config = Object.assign(state.config, action.payload);
			});
			builder.addCase(getClassSessionConfig.rejected, (state, action) => {
			console.log('getClassSessionConfig.rejected action', action);
			console.log(
				'getClassSessionConfig.rejected action payload',
				action.payload
			);
			state.config.pending = false;
			state.config.complete = false;

			// if (action.error.message && action.error.message.contains("404")){
			// 	// state.config = Object.assign(state.config, {
			// 	// 	Enabled : false,
			// 	// 	ReminderBeforeDays : 0,
			// 	// 	ReminderBeforeMinutes : 0
			// 	// });
			// 	//state.config.complete = true;
			// }

			state.config.error = action.error ? action.error.message! : '';
		});

		//enableClassSession
		builder.addCase(enableClassSession.pending, (state) => {
			console.log('enableClassSession.pending');
			state.config.pending = true;
			state.config.complete = false;
			state.config.error = '';
		});
		builder.addCase(enableClassSession.fulfilled, (state, action) => {
			console.log('enableClassSession.fulfilled ', action);
			state.config.pending = false;
			state.config.complete = true;
			state.config = Object.assign(state.config, action.payload);
		});
		builder.addCase(enableClassSession.rejected, (state, action) => {
			console.log('enableClassSession.rejected action', action);
			console.log('enableClassSession.rejected action payload', action.payload);
			state.config.pending = false;
			state.config.complete = false;
			state.config.error = action.error ? action.error.message! : '';
		});

		//updateConfig
		builder.addCase(updateConfig.pending, (state) => {
			console.log('updateConfig.pending');
			state.config.pending = true;
			state.config.complete = false;
			state.config.error = '';
		});
		builder.addCase(updateConfig.fulfilled, (state, action) => {
			console.log('updateConfig.fulfilled ', action);
			state.config.pending = false;
			state.config.complete = true;
			state.config = Object.assign(state.config, action.payload);
		});
		builder.addCase(updateConfig.rejected, (state, action) => {
			console.log('updateConfig.rejected action', action);
			console.log('updateConfig.rejected action payload', action.payload);
			state.config.pending = false;
			state.config.complete = false;
			state.config.error = action.error ? action.error.message! : '';
		});

		//updateReminders : Deprecated 
		builder.addCase(updateReminders.pending, (state) => {
			console.log('updateReminders.pending');
			state.config.pending = true;
			state.config.complete = false;
			state.config.error = '';
		});
		builder.addCase(updateReminders.fulfilled, (state, action) => {
			console.log('updateReminders.fulfilled ', action);
			state.config.pending = false;
			state.config.complete = true;
			state.config = Object.assign(state.config, action.payload);
		});
		builder.addCase(updateReminders.rejected, (state, action) => {
			console.log('updateReminders.rejected action', action);
			console.log('updateReminders.rejected action payload', action.payload);
			state.config.pending = false;
			state.config.complete = false;
			state.config.error = action.error ? action.error.message! : '';
		});
  	},
});

export const { accountSliceClean } = accountClassSessionConfigSlice.actions;
export default accountClassSessionConfigSlice;
